<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/wanzhuan-problem" class="f16 fw">常见问题解答</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
      <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center">
          <div class="yj-nav-box ">
            <router-link to="/pages/wanzhuan/index" class="yj-nav-link db f24">开园时间</router-link>
          </div>
          <div class="yj-nav-box ">
            <router-link to="/pages/wanzhuan/wanzhuan-notice" class="yj-nav-link db f24">游园须知</router-link>
          </div>
          <div class="yj-nav-box active">
            <router-link to="/pages/wanzhuan/wanzhuan-problem" class="yj-nav-link db f24">常见问题解答</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="wz-problem mt50 pb100 w1200 auto">
      <div v-for="(category, index) in data" :key="index" :class="index != 0 ? 'mt50' : ''">
        <div class="f32 b" v-if="category.name">{{ category.name }}</div>
        <div class="wz-problem-item mt15" v-if="category.list && category.list.length > 0">
          <div class="wz-problem-box" v-for="item in category.list" :key="item.Id" @click="item.active = !item.active" :class="item.active ? 'active' : ''">
            <div class="wz-problem-wen  df align_center">
              <img src="@/assets/images/wz-icon1.png" class="db mr12" alt="" />
              <div class="f18 line_clamp1 mra">{{ item.Name }}</div>
              <img src="@/assets/images/arrow-y2.png" class="db w20 wz-problem-arrow" alt="" />
            </div>
            <div class="wz-problem-da" :class="item.active ? 'df' : 'dn'">
              <div>
                <img src="@/assets/images/wz-icon2.png" class="db mr12" alt="" />
              </div>
              <div class="wz-problem-da-text fw tj f20 lh18 f1" v-html="item.ContentText">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="f32 b">交通类</div>
      <div class="wz-problem-item mt15" v-if="jtData && jtData.length > 0">
        <div class="wz-problem-box" v-for="item in jtData" :key="item.Id" @click="item.active = !item.active" :class="item.active ? 'active' : ''">
          <div class="wz-problem-wen  df align_center">
            <img src="@/assets/images/wz-icon1.png" class="db mr12" alt="" />
            <div class="f18 line_clamp1 mra">{{ item.Name }}</div>
            <img src="@/assets/images/arrow-y2.png" class="db w20 wz-problem-arrow" alt="" />
          </div>
          <div class="wz-problem-da" :class="item.active ? 'df' : 'dn'">
            <div>
              <img src="@/assets/images/wz-icon2.png" class="db mr12" alt="" />
            </div>
            <div class="wz-problem-da-text fw tj f20 lh18 f1" v-html="item.ContentText">
            </div>
          </div>
        </div>
      </div>
      <div class="f32 b mt50">门票相关</div>
      <div class="wz-problem-item mt15" v-if="mpData && mpData.length > 0">
        <div class="wz-problem-box" v-for="item in mpData" :key="item.Id" @click="item.active = !item.active" :class="item.active ? 'active' : ''">
          <div class="wz-problem-wen  df align_center">
            <img src="@/assets/images/wz-icon1.png" class="db mr12" alt="" />
            <div class="f18 line_clamp1 mra">{{ item.Name }}</div>
            <img src="@/assets/images/arrow-y2.png" class="db w20 wz-problem-arrow" alt="" />
          </div>
          <div class="wz-problem-da" :class="item.active ? 'df' : 'dn'">
            <div>
              <img src="@/assets/images/wz-icon2.png" class="db mr12" alt="" />
            </div>
            <div class="wz-problem-da-text fw tj f20 lh18 f1" v-html="item.ContentText">
            </div>
          </div>
        </div>
      </div> -->


    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      data: [
        {
          code: 'app-wzfl-ryzn-cjwtjd-ms',
          list: null,
          name: null,
        },
        {
          code: 'app-wzfl-ryzn-cjwtjd-zs',
          list: null,
          name: null,
        },
        {
          code: 'app-wzfl-ryzn-cjwtjd-jt',
          list: null,
          name: null,
        },
        {
          code: 'app-wzfl-ryzn-cjwtjd-yw',
          list: null,
          name: null,
        },
        {
          code: 'app-wzfl-ryzn-cjwtjd-mpxg',
          list: null,
          name: null,
        },
        {
          code: 'app-wzfl-ryzn-cjwtjd-qt',
          list: null,
          name: null,
        }
      ],
      jtCode: 'app-wzfl-ryzn-cjwtjd-jt',
      jtData: null,
      mpCode: 'app-wzfl-ryzn-cjwtjd-mpxg',
      mpData: null,
    }
  },
  components: { Header, Bottom,},
  mounted(){
    // this.loadJtData();
    // this.loadMpData();
    this.loadData();
  },
  methods:{
    loadData() {
      this.data.forEach(item => {
        promotionService.detail(item.code).then(res => {
          if(res.Code == 200 && res.Data) {
            let data = res.Data;
            if(data.Items) {
              data.Items.forEach(item => {
                item.active = false;
              });
            }

            item.list = data.Items;
            item.name = data.Name;
          }
        })
      });
    },
    loadJtData() {
      promotionService.detail(this.jtCode).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          data.Items.forEach(item => {
            item.active = false;
          });

          this.jtData = data.Items;
        }
      })
    },
    loadMpData() {
      promotionService.detail(this.mpCode).then(res => {
        if(res.Code == 200) {
          let data = res.Data;

          data.Items.forEach(item => {
            item.active = false;
          });

          this.mpData = data.Items;
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/wanzhuan/wanzhuan-problem.vue